import request from './http';
export const getObj = (id) => request({
  url: '/jetlinks/visualization/catalog/' + encodeURIComponent(id),
  method: 'GET'
});

export const updateOne = (id, data) => request({
  url: '/jetlinks/visualization/catalog/' + encodeURIComponent(id), method: 'PUT', data
});

export const queryList = (params) => request({
  url: '/jetlinks/visualization/catalog/_query',
  method: 'GET',
  params
});

export const queryTree = (params) => request({
  url: '/jetlinks/visualization/catalog/_query/tree',
  method: 'GET',
  params
});

export const save = (params) => request({
  url: '/jetlinks/visualization/catalog',
  method: 'POST',
  data: params
});

export const update = (params) => request({
  url: '/jetlinks/visualization/catalog',
  method: 'PATCH',
  data: params
});

export const remove = (id) => request({
  url: '/jetlinks/visualization/catalog/' + id,
  method: 'DELETE'
});

